import { REGION_MODE } from './config';
export function baiduStatics() {
  const hm = document.createElement('script');
  // 国内
  if (REGION_MODE == 'cn') {
    hm.src = 'https://hm.baidu.com/hm.js?10523e120b10832ac95ebd851d750056';
  } else {
    // 海外
    hm.src = 'https://hm.baidu.com/hm.js?0420bde41e6f08af402c3f05b70bba99';
  }
  const s: any = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(hm, s);
}
